import { BRAND_THEME } from "./brandTheme";

/**
 * Compact statistic card — Patient-branded (indigo), used by Dashboard
 * employee counts and similar overview grids.
 */
export default function StatCard({
  label,
  value,
  hint = "Active Staff",
  icon: Icon,
  onClick,
  theme = BRAND_THEME,
}) {
  const interactive = typeof onClick === "function";

  return (
    <div
      role={interactive ? "button" : undefined}
      tabIndex={interactive ? 0 : undefined}
      onClick={onClick}
      onKeyDown={
        interactive
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick(e);
              }
            }
          : undefined
      }
      className={`bg-white p-5 rounded-xl border ${theme.section.wrap} shadow-sm transition-all duration-200 ${
        interactive
          ? "cursor-pointer hover:shadow-md hover:border-indigo-300 group"
          : ""
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p
            className={`text-sm font-medium mb-1 truncate ${theme.section.title}`}
          >
            {label}
          </p>
          <h3 className="text-3xl font-bold text-slate-900 tabular-nums">
            {value}
          </h3>
          {hint ? (
            <span className="text-xs text-slate-400 mt-1 block">{hint}</span>
          ) : null}
        </div>
        {Icon ? (
          <div
            className={`p-3 rounded-lg shrink-0 bg-indigo-50 text-indigo-600 ${
              interactive
                ? "group-hover:scale-105 transition-transform duration-200"
                : ""
            }`}
          >
            <Icon size={24} />
          </div>
        ) : null}
      </div>
    </div>
  );
}
